import { base64ToArrayBuffer } from '@plug-core/utils/arrayBuffer'
import { toHex } from '@plug-core/utils/hex'
import { generate } from 'candid-parse'

export const decodeCallArgs = async (methodName: string, args: string, candid: string) => {
  const enc = new TextEncoder()
  const parsedString = generate(
    toHex(enc.encode(candid)),
    methodName,
    toHex(base64ToArrayBuffer(args))
  )
  return parsedString
}
